import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import HttpService from '../../../utils/httpService';
import CommonContent from '../../CommonContent';
import './PoliticsNewsSection.css';

const PoliticsNewsSection = () => {
    const [news, setNews] = useState([]);
    const [page, setPage] = useState(1);
    const [loadingMore, setLoadingMore] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const location = useLocation();
    const isDashboard = location.search.includes('dashboard=true');

    const fetchNews = async (pageNum, isLoadMore = false) => {
        try {
            if (isLoadMore) setLoadingMore(true);
            const url = `${HttpService.category}politics?page=${pageNum}&limit=10`;
            const res = await axios.get(url);
            const newPosts = res?.data?.data?.posts || [];

            if (newPosts.length < 10) setHasMore(false);

            if (isLoadMore) {
                setNews(prev => [...prev, ...newPosts]);
            } else {
                setNews(newPosts);
            }
            setLoadingMore(false);
        } catch (err) {
            console.error("Error fetching politics news:", err);
            setLoadingMore(false);
        }
    };

    useEffect(() => {
        fetchNews(1);
    }, []);

    const handleLoadMore = () => {
        const nextPage = page + 1;
        setPage(nextPage);
        fetchNews(nextPage, true);
    };

    if (!news || news.length === 0 || isDashboard) return null;

    const featured = news[0];
    const sideList = news.slice(1, 4);
    const bottomGrid = news.slice(4);

    return (
        <section className="politics-news-section-premium">
            <div className="container">
                <div className="section-header-premium">
                    <h2 className="title-guj">રાજકારણ સમાચાર</h2>
                    <h3 className="title-eng">POLITICS NEWS</h3>
                    <div className="accent-line"></div>
                </div>

                <div className="news-main-container">
                    <div className="row">
                        {/* Featured Article */}
                        <div className="col-xl-8 col-lg-12 featured-vault">
                            <Link to={`/${featured.url}${isDashboard ? '?dashboard=true' : ''}`} className="featured-story-link">
                                <div className="featured-image-wrap">
                                    <img
                                        src={`${featured.media}`}
                                        alt={featured.media_title}
                                    />
                                    {featured.post_type === 4 && (
                                        <div className="play-overlay"><i className="fas fa-play"></i></div>
                                    )}
                                    <div className="featured-caption">
                                        <span className="tag-badge">{featured.tagline || 'POLITICS'}</span>
                                        <h1 className="featured-title">{featured.title}</h1>
                                        <p className="featured-meta">
                                            <i className="far fa-clock"></i> {featured.publish_date}
                                        </p>
                                    </div>
                                </div>
                            </Link>
                        </div>

                        {/* Side List */}
                        <div className="col-xl-4 col-lg-12 side-rail-vault">
                            {sideList.map((item, idx) => (
                                <Link key={idx} to={`/${item.url}${isDashboard ? '?dashboard=true' : ''}`} className="side-item-link">
                                    <div className="side-item-thumb">
                                        <img src={`${item.media}`} alt="" />
                                        {item.post_type === 4 && <i className="fas fa-play mini-play"></i>}
                                    </div>
                                    <div className="side-item-info">
                                        <span className="side-tag">{item.tagline}</span>
                                        <h2 className="side-title">{item.title}</h2>
                                        {/* <span className="side-time">{item.publish_date}</span> */}
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>

                    {/* Bottom Grid */}
                    <div className="row bottom-grid-vault">
                        {bottomGrid.map((item, idx) => (
                            <div key={idx} className="col-md-4 col-sm-6">
                                <Link to={`/${item.url}${isDashboard ? '?dashboard=true' : ''}`} className="grid-item-link">
                                    <div className="grid-thumb">
                                        <img src={`${item.media}`} alt="" />
                                        {item.post_type === 4 && <i className="fas fa-play mini-play"></i>}
                                    </div>
                                    <div className="grid-info">
                                        <h3 className="grid-title">{item.title}</h3>
                                        <span className="grid-time">{item.publish_date}</span>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>

                {hasMore && (
                    <div className="load-more-wrap">
                        <button
                            className="load-more-btn"
                            onClick={handleLoadMore}
                            disabled={loadingMore}
                        >
                            {loadingMore ? 'લોડ થઈ રહ્યું છે...' : 'વધુ સમાચાર જુઓ'}
                            {!loadingMore && <i className="fas fa-chevron-down"></i>}
                        </button>
                    </div>
                )}
            </div>
        </section>
    );
};

export default PoliticsNewsSection;
